import { useQuery } from "@tanstack/react-query";
import type { ThemeListResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useThemesQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.themes(),
    queryFn: () => apiJsonClient<ThemeListResponse>(endpoints.admin.themes),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
